import Toolbar from '@mui/material/Toolbar';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import UserAvatar from '../../components/UserAvatar/UserAvatar';
import NRPendoMarkIcon from '../../components/../NRIcons/NRPendoMarkIcon';
import IconButton from '@mui/material/IconButton';
import NROrgSelector from './NROrgSelector/NROrgSelector';
import NRSideNavbar from './NRSideNavbar/NRSideNavbar';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import { useTheme } from '@mui/material/styles';
import NRNotificationsInApp from '../../components/NRNotificationsInApp/NRNotificationsInApp';
import { FEATURE_FLAGS } from '../../constants/constants';
import { useFlag } from '@openfeature/react-sdk';

export const drawerWidth = 72;

function NRMenu({ children }) {
  // TODO: Remove this flag once the notifications are fully implemented - [TURB-5126]
  const { value: isNotificationsEnable } = useFlag(FEATURE_FLAGS.NOTIFICATIONS, false);
  const trigger = useScrollTrigger({ threshold: 10, disableHysteresis: true });
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar
        position="fixed"
        color="default"
        sx={{
          boxShadow: !trigger ? 'unset' : undefined
        }}
      >
        <Toolbar
          sx={{
            display: 'flex',
            flexFlow: 'column',
            paddingRight: 0
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              display: 'flex',
              flexFlow: 'row',
              justifyContent: 'space-between'
            }}
          >
            <NROrgSelector />
            <Box
              sx={{
                color: theme.palette.text.icon,
                display: 'flex',
                alignSelf: 'center',
                gap: theme.spacing(2),
                marginLeft: 'auto',
                marginRight: theme.spacing(2)
              }}
            >
              {isNotificationsEnable && <NRNotificationsInApp />}
              <IconButton
                sx={{
                  width: theme.spacing(4.5),
                  height: theme.spacing(4.5),
                  alignSelf: 'center'
                }}
                size="small"
                color="inherit"
                id="res-center"
              >
                <NRPendoMarkIcon />
              </IconButton>
            </Box>
            <UserAvatar
              sx={{
                alignSelf: 'center',
                paddingRight: theme.spacing(2)
              }}
            />
          </Box>
        </Toolbar>
      </AppBar>
      <NRSideNavbar />
      <Box
        component="main"
        sx={{
          [theme.breakpoints.down('lg')]: {
            padding: theme.spacing(2, 1, 2, 1),
            paddingTop: 0
          },
          [theme.breakpoints.up('md')]: {
            padding: theme.spacing(2),
            paddingTop: 0
          },
          [theme.breakpoints.up('sm')]: {
            height: 'calc(100vh - 64px)', // 64px is the height of the app bar
            marginTop: '64px'
          },
          [theme.breakpoints.down('md')]: {
            height: 'calc(100vh - 72px)', // 72px is the height of the app bar
            marginTop: '56px'
          },
          flexGrow: 1,
          width: '80vw',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

export default NRMenu;
